import React from 'react';
import { Tabs } from 'antd';
import JsonParserWithViewer from '../../shared/components/json/JsonParserWithViewer';
import JsonDiffViewer from '../../shared/components/json/JsonDiffViewer';

// 1. 탭 데이터를 배열 형태로 정의합니다.
const tabItems = [
    {
        key: 'view',
        label: '📂 JSON 보기',
        children: <JsonParserWithViewer />,
    },
    {
        key: 'diff',
        label: '🆚 JSON 비교',
        children: <JsonDiffViewer enableDiffNavigation />,
    },
];

const JsonParserPage = () => {
    return (
        <div style={{ padding: 24 }}>
            {/* 2. 기존의 Tabs.TabPane 대신 items prop을 사용합니다. */}
            <Tabs
                defaultActiveKey="view"
                type="card"
                items={tabItems}
            />
        </div>
    );
};

export default JsonParserPage;